/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Activity_Drag_Not_YoursInputs */

const vi_work_activity_drag_not_yours = /** @type {(inputs: Work_Activity_Drag_Not_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ người được giao hoặc người giao việc mới đổi được trạng thái nhiệm vụ này.`)
};

/**

* @param {Work_Activity_Drag_Not_YoursInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const work_activity_drag_not_yours = /** @type {((inputs?: Work_Activity_Drag_Not_YoursInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Activity_Drag_Not_YoursInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_work_activity_drag_not_yours(inputs)
});